// extracted by mini-css-extract-plugin
export default {"DrawerSVG":"DrawerSVG_DrawerSVG__ETnwz"};